export const locales = ['en', 'tr', 'es', 'fr', 'de', 'pt', 'ar', 'hi', 'ja', 'ko', 'id', 'vi', 'ru', 'it', 'pl', 'nl'] as const;
export const nonLatinLocales = ['ar', 'hi', 'ja', 'ko'] as const;
export const rtlLocales = ['ar', 'he', 'fa'] as const;
export const localeRegex = new RegExp(`^(${locales.join('|')})\\/`);
export type Locale = typeof locales[number];

export const languages = [
    { code: 'en', name: 'English', flag: 'https://flagcdn.com/w160/us.png' },
    { code: 'es', name: 'Español', flag: 'https://flagcdn.com/w160/es.png' },
    { code: 'pt', name: 'Português', flag: 'https://flagcdn.com/w160/pt.png' },
    { code: 'hi', name: 'हिंदी', flag: 'https://flagcdn.com/w160/in.png' },
    { code: 'ar', name: 'العربية', flag: 'https://flagcdn.com/w160/sa.png' },
    { code: 'fr', name: 'Français', flag: 'https://flagcdn.com/w160/fr.png' },
    { code: 'de', name: 'Deutsch', flag: 'https://flagcdn.com/w160/de.png' },
    { code: 'ja', name: '日本語', flag: 'https://flagcdn.com/w160/jp.png' },
    { code: 'tr', name: 'Türkçe', flag: 'https://flagcdn.com/w160/tr.png' },
    { code: 'ko', name: '한국어', flag: 'https://flagcdn.com/w160/kr.png' },
    { code: 'id', name: 'Bahasa Indonesia', flag: 'https://flagcdn.com/w160/id.png' },
    { code: 'vi', name: 'Tiếng Việt', flag: 'https://flagcdn.com/w160/vn.png' },
    { code: 'ru', name: 'Русский', flag: 'https://flagcdn.com/w160/ru.png' },
    { code: 'it', name: 'Italiano', flag: 'https://flagcdn.com/w160/it.png' },
    { code: 'pl', name: 'Polski', flag: 'https://flagcdn.com/w160/pl.png' },
    { code: 'nl', name: 'Nederlands', flag: 'https://flagcdn.com/w160/nl.png' },
];